import { API_ENDPOINT } from '../config';

export default function() {
    return fetch(`${API_ENDPOINT}/auth/session/`);
}
